const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '훈련일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: { hiddenList: ['훈련일', '작성일', '작성년도'] }
      },
      {
        'component': 'search-year', label: '연도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear()
        }
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      let dateTarget = "created_at";
      let dateBegin = `${new Date().getFullYear()}-01-01`;
      let dateEnd = `${new Date().getFullYear()}-12-31`;
      dateBegin = `${search.year}-01-01`;
      dateEnd = `${search.year}-12-31`;
      conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
      conditions.push({key: dateTarget, operator: '<', value: new Date(dateEnd).addDays(1).format("yyyy-MM-dd")})
    }

    //  검색일
    if (search.date) {
      conditions.push({key: 'body.훈련정보.훈련일', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.훈련정보.훈련일', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {name: '작성년도', key: 'body.stdInfo.date'},
      {name: '부서', key: 'body.stdInfo.field_name'},
      {name: '훈련시기', key: 'body.훈련정보.훈련시기'},
      {name: '훈련구분', key: 'body.훈련정보.훈련구분'},
      {name: '훈련일', key: 'body.훈련정보.훈련일'},
      {name: '소속명', key: 'body.stdInfo.department'},
      {name: '부서명', key: 'body.stdInfo.section'},
      {name: '작성자', key: 'body.stdInfo.writer_name'},
      {name: '작성일', key: 'created_at'},
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.date? func.getContent(value).stdInfo.date.split('-')[0] : '' // 작성년도

        case 1: return func.getContent(value).stdInfo.field_name
        case 2: return func.getContent(value).훈련정보.훈련시기
        case 3: return func.getContent(value).훈련정보.훈련구분
        case 4: return func.getContent(value).훈련정보.훈련일
        case 5: return func.getContent(value).stdInfo.department
        case 6: return func.getContent(value).stdInfo.section
        case 7: return func.getContent(value).stdInfo.writer_name
        case 8: return func.getCreatedDate(value.created_at)
      }
    } catch (e) { /*ignore*/
    }
    return ''
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}

export default list;
